// extracted by mini-css-extract-plugin
module.exports = {"dropdownContainer":"styles_dropdownContainer__9911T","defaultTriggerClassName":"styles_defaultTriggerClassName__Gw1P0"};